// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PruebaDetalle_spinnerContainer__yS9p5"};